import React, { useState, useCallback, useEffect } from "react";
import "./uploadMaster.css";
import api from "../../../utils/api";
import { toast } from "react-hot-toast";

const UploadMaster = ({ close, table }) => {
  const [file, setFile] = useState();
  const [isDragging, setIsDragging] = useState(false);
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");

  const handleUpload = (e) => {
    setFile(e.target.files[0]);
  };

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    setIsDragging(false);
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    setIsDragging(false);
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile) {
      setFile(droppedFile);
    }
  }, []);

  const handleFileUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      toast.error("Please select a file first");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const url =
        table !== "teachers" ? `?academic_year_id=${selectedYear?.id}` : "";
      await api
        .post(`/${table}/upload${url}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => window.location.reload());
    } catch (err) {
      if (err.response && err.response.data) {
        toast.error(JSON.stringify(err.response.data));
      } else {
        console.error("An unexpected error occurred:", err);
      }
    }
  };

  const handleYearChange = (e) => {
    const year = academicYears.find((y) => y.label === e.target.value);
    setSelectedYear(year);
  };

  const fetchData = async () => {
    await api
      .get("/academic")
      .then((response) => response.data)
      .then((data) => {
        const activeYear = data?.find((item) => item?.is_active);
        const formattedActiveYear = {
          label:
            new Date(activeYear?.start_date).getFullYear() +
            "-" +
            new Date(activeYear?.end_date).getFullYear(),
          from: activeYear?.start_date,
          to: activeYear?.end_date,
          id: activeYear?.id,
        };
        setSelectedYear(formattedActiveYear);
        setAcademicYears(
          data
            ?.filter((item) => !item?.is_active)
            .map((item) => ({
              label:
                new Date(item?.start_date).getFullYear() +
                "-" +
                new Date(item?.end_date).getFullYear(),
              from: item?.start_date,
              to: item?.end_date,
              id: item?.id,
            }))
        );
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div
      className="delete-card upload-master"
      style={{ height: "fit-content" }}
    >
      <form
        onSubmit={handleFileUpload}
        style={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        {table !== "teachers" && (
          <div>
            <label style={{ marginRight: "8px" }}>Academic Year</label>
            <select
              value={selectedYear?.label}
              onChange={handleYearChange}
              style={{ padding: "8px", border: "1px solid #000" }}
            >
              <option value={""} style={{ pointerEvents: "none" }}>
                {selectedYear?.label || "Select Academic Year"}
              </option>
              {academicYears?.map((year) => (
                <option key={year?.label} value={year?.label}>
                  {year?.label}
                </option>
              ))}
            </select>
          </div>
        )}
        <div
          className={`drop-zone ${isDragging ? "dragging" : ""}`}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <input
            type="file"
            name="file"
            onChange={handleUpload}
            id="file-input"
            className="file-input"
          />
          <label htmlFor="file-input" className="file-label">
            {file ? (
              <div className="file-info">
                <span className="file-name">{file.name}</span>
                <span className="file-size">
                  ({(file.size / 1024).toFixed(2)} KB)
                </span>
              </div>
            ) : (
              <div className="upload-placeholder">
                <i className="upload-icon">📁</i>
                <p>Drag & drop your file here or click to browse</p>
              </div>
            )}
          </label>
        </div>

        <div>
          <button type="submit" className="upload_btn">
            Upload
          </button>
          <button type="button" onClick={close} className="cancel_btn">
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default UploadMaster;
